import { Link } from 'react-router-dom';
import { ArrowRight } from 'lucide-react';

export const ClientsCTA = () => (
  <section className="py-24 bg-[#f8fafc]" data-testid="clients-cta">
    <div className="max-w-7xl mx-auto px-6 lg:px-8">
      <div className="relative rounded-3xl bg-gradient-to-r from-[#3b5998] to-[#00bcd4] p-12 lg:p-16 overflow-hidden">
        <div className="absolute inset-0 opacity-10">
          <div className="absolute top-0 right-0 w-96 h-96 bg-white rounded-full blur-3xl -translate-y-1/2 translate-x-1/2"></div>
        </div>
        <div className="relative text-center">
          <h2 className="font-heading text-3xl sm:text-4xl font-semibold text-white mb-4">
            Join Our Growing List of Satisfied Clients
          </h2>
          <p className="text-white/80 max-w-2xl mx-auto mb-8">
            Let us help you navigate government subsidies and secure the financing 
            your business needs to grow.
          </p>
          <Link
            to="/contact"
            data-testid="clients-contact-cta"
            className="px-10 py-4 bg-white text-[#3b5998] rounded-full font-medium hover:bg-white/90 transition-colors inline-flex items-center gap-2"
          >
            Become a Client
            <ArrowRight size={18} />
          </Link>
        </div>
      </div>
    </div>
  </section>
);
